import { defineMessages } from 'react-intl';

export default defineMessages({
  personalInfo: {
    id: 'signup.personal_info',
  },
  validation: {
    id: 'signup.validation',
  },
  idAndPassword: {
    id: 'signup.id_and_password',
  },
});
